module.exports = __webpack_public_path__ + "img/HINDU DIWALI RED.1560df0.svg";